import StatisticBlock from '@/components/StatisticBlock/StatisticBlock';
export default StatisticBlock;
